<!--
 * Created by JackCui on 2021/12/15
 -->

<script>
  import {assignWith, isUndefined} from 'lodash-es'

  export default {
    name: 'pagination',
    props: {
      paginationOpt: Object
    },
    computed: {
      pagination () {
        // 合并分页器配置参数
        return assignWith(
          this.paginationOpt,
          {
            page: 0,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            total: 0
          },
          (objValue, srcValue) => isUndefined(objValue) ? srcValue : objValue
        )
      }
    },
    render (h) {
      const {total, pageSize, pageSizes, page, disabled} = this.pagination
      return (
        <el-pagination
          class="pagination"
          background={true}
          page-sizes={pageSizes}
          page-size={pageSize}
          current-page={page}
          layout="total, prev, pager, next, sizes, jumper"
          total={total}
          disabled={disabled}
          on-current-change={this.handlePageChange}
          on-size-change={this.handleSizeChange}
        />
      )
    },
    methods: {
      handlePageChange (page) {
        this.$set(this.paginationOpt, 'page', page)
        this.$emit('page-change', this.pagination)
      },
      handleSizeChange (size) {
        this.$set(this.paginationOpt, 'pageSize', size)
        this.handlePageChange(1)
      }
    }
  }
</script>

<style scoped lang="scss">
  div.el-pagination {
    font-weight: normal;

    ::v-deep .el-pagination__total,
    ::v-deep .btn-prev,
    ::v-deep .btn-prev .el-icon,
    ::v-deep .btn-next,
    ::v-deep .btn-next .el-icon,
    ::v-deep .el-pager li,
    ::v-deep .el-pagination__sizes .el-input input.el-input__inner,
    ::v-deep .el-pagination__jump {
      color: #636E95;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li,
    ::v-deep .el-pagination__sizes .el-input input.el-input__inner,
    ::v-deep .el-pagination__jump .el-pagination__editor input.el-input__inner {
      border: 1px solid;
      border-color: #EDEFF4 !important;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li,
    ::v-deep .el-pagination__sizes .el-input input.el-input__inner,
    ::v-deep .el-pagination__jump .el-pagination__editor input.el-input__inner {
      border-radius: 2px;
    }

    ::v-deep .el-input__validateIcon {
      display: none;
    }
  }
</style>
